import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

export interface ActionCardData {
  title: string;
  description: string;
  buttonText: string;
  routerLink: string;
}

/**
 * WHY: Clean action card with primary/secondary color variants
 * SOLID: Single responsibility - displays action prompts with routing
 */
@Component({
  selector: 'action-card',
  templateUrl: './action-card.component.html',
  imports: [CommonModule, RouterModule]
})
export class ActionCardComponent {
  @Input() data!: ActionCardData;
  @Input() variant: 'primary' | 'secondary' = 'primary';
  
  protected getCardClasses(): string {
    return this.variant === 'primary' 
      ? 'bg-white'
      : 'bg-gradient-to-r from-brand-goldline/20 to-brand-nude/30';
  }
  
  protected getTextClasses(): string {
    return this.variant === 'primary'
      ? 'font-[Neuton] text-brand-inktint/80'
      : 'font-[Neuton] text-brand-inktint/80';
  }
  
  protected getButtonClasses(): string {
    return this.variant === 'primary'
      ? 'bg-brand-goldline text-white hover:bg-brand-goldline/90'
      : 'bg-brand-inktint text-brand-briefcream hover:bg-brand-inktint/90 shadow-lg hover:shadow-xl';
  }
}